export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PrimaryButton.vue?vue&type=template&id=172d266b&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PrimaryButton.vue?vue&type=template&id=172d266b&scoped=true&
// module id = 97
// module chunks = 0